// extracted by mini-css-extract-plugin
module.exports = {"content-objectives-wrapper":"ContentObjectives_content-objectives-wrapper__OR8M_"};